import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { useContext } from 'react';
import { OneXPContext } from 'src/utils/onexp.utils';

const featureFlagQueryKey = 'featureFlag';
const featureFlagPropertiesQueryKey = 'featureFlagProperties';
const experimentQueryKey = 'experiment';

export const useFeatureFlag = (flagName: string): UseQueryResult<boolean> => {
    const sdkClient = useContext(OneXPContext);
    return useQuery<boolean>({
        queryKey: [featureFlagQueryKey, flagName],
        queryFn: async () => {
            const response = await sdkClient.getFeatureFlag(flagName);
            return response?.enabled;
        },
        enabled: Boolean(flagName)
    });
};

export const useFeatureFlagProperties = (flagName: string): UseQueryResult<{ [key: string]: string }> => {
    const sdkClient = useContext(OneXPContext);
    return useQuery<{ [key: string]: string }>({
        queryKey: [featureFlagPropertiesQueryKey, flagName],
        queryFn: async () => {
            const response = await sdkClient.getFeatureFlag(flagName);
            return response?.enabled ? response?.properties || {} : null; // null indicates feature flag disabled (or still loading)
        }
    });
};

export const useExperiment = (
    experimentName: string,
    dimension: string,
    defaultVariant: string
): UseQueryResult<string> => {
    const sdkClient = useContext(OneXPContext);
    return useQuery<string>({
        queryKey: [experimentQueryKey, experimentName, dimension, defaultVariant],
        queryFn: async () => {
            const variant = await sdkClient.getVariant(experimentName, dimension, defaultVariant);
            return variant;
        },
        enabled: Boolean(experimentName) && Boolean(dimension) && Boolean(defaultVariant)
    });
};
